import { Accordion } from '../../../../../components/general/accordion';
import { PqrInitialCausalityProps } from '../../form/initialCausality/props';
import { PqrInitialCausality as Component } from '../../form/initialCausality';

export const PqrInitialCausality = (props: PqrInitialCausalityProps) => {
    return (
        <Accordion
            title="Causalidad Inicial"
            defaultExpanded={false}
            icon={
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    height="20px"
                    viewBox="0 0 225.000000 225.000000"
                    preserveAspectRatio="xMidYMid meet"
                >
                    <g
                        transform="translate(0.000000,225.000000) scale(0.100000,-0.100000)"
                        fill="#000000"
                        stroke="none"
                    >
                        <path
                            d="M1065 2178 c-153 -168 -264 -398 -309 -637 -27 -142 -27 -142 55
          -192 89 -53 166 -113 246 -190 34 -32 64 -59 66 -59 3 0 27 21 53 46 81 76
          185 156 263 203 l73 45 -6 75 c-19 212 -107 439 -240 621 -46 64 -125 150
          -137 150 -4 0 -33 -28 -64 -62z"
                        />
                        <path
                            d="M5 1253 c23 -331 161 -636 394 -873 171 -174 415 -311 649 -364 70
          -16 77 -16 155 3 248 59 466 180 638 352 243 245 379 540 404 882 l7 97 -60 0
          c-82 0 -260 -32 -356 -64 -256 -86 -493 -260 -667 -491 -23 -30 -43 -55 -44
          -55 -2 0 -21 24 -42 52 -166 228 -411 407 -679 496 -97 32 -266 62 -354 62
          l-52 0 7 -97z"
                        />
                    </g>
                </svg>
            }
            mt="20px"
            padding="0 0 10px"
        >
            <Component {...props} showTitle={false} />
        </Accordion>
    );
};
